import { render } from "./TheSiteHeader.vue?vue&type=template&id=10ef617a&scoped=true"
import script from "./TheSiteHeader.vue?vue&type=script&lang=js"
export * from "./TheSiteHeader.vue?vue&type=script&lang=js"

import "./TheSiteHeader.vue?vue&type=style&index=0&id=10ef617a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10ef617a"

export default script